import { createContext } from "react";

import { type SSOService } from "../SSOService";

export const SnapSSOAuthContext = createContext<SSOService | null>(null);
